import React from 'react';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import InputField from 'components/pure/utils/form/InputField';
import './ParticipantPreparation.styl';

export default class ParticipantPreparation extends React.PureComponent {
  static defaultProps = {
    min: 1,
  };

  render() {
    const {preparation, onChange, disabled, min} = this.props;
    return (
      <div className="participant-preparation">
        <label className="calls-for-discussion">
          <InputField
            value={preparation.prepNumberOfCalls}
            type="number"
            size={4}
            min={min}
            onChange={value => onChange(preparation.set('prepNumberOfCalls', value))}
            disabled={disabled}
          />
          <div className={'add-call-instruction'}>Should add this many calls for discussion</div>
        </label>
        <CheckboxField
          label="Should comment on each call"
          checked={preparation.prepShouldComment}
          onCheck={(_, value) => onChange(preparation.set('prepShouldComment', value))}
          disabled={disabled}
        />
        <CheckboxField
          label="Should score each call"
          checked={preparation.prepShouldScore}
          onCheck={(_, value) => onChange(preparation.set('prepShouldScore', value))}
          disabled={disabled}
        />
      </div>
    );
  }
}
